import { SuretyAccountId } from "@inrev/common";
import { Card } from "@portal/components/primitives";
import { getDefaultTab, type Tab, TabBar } from "@portal/components/ui/TabBar";
import { FC, useState } from "react";
import { AccountTabProps } from "../../../AccountLayout";
import { AdminAccountBondsTable } from "../../AdminAccountBondsTable";

type BondSectionTab = { accountId: SuretyAccountId };

const AllBondsTab = ({ accountId }: BondSectionTab) => (
	<AdminAccountBondsTable accountId={accountId} tableName="admin_account_all_bonds_table" />
);

const OpenBondsTab = ({ accountId }: BondSectionTab) => (
	<AdminAccountBondsTable
		accountId={accountId}
		tableName="admin_account_open_bonds_table"
		status="open"
	/>
);

const ClosedBondsTab = ({ accountId }: BondSectionTab) => (
	<AdminAccountBondsTable
		accountId={accountId}
		tableName="admin_account_closed_bonds_table"
		status="closed"
	/>
);

const BOND_SECTION_TABS: [Tab<BondSectionTab>, Tab<BondSectionTab>, Tab<BondSectionTab>] = [
	{ id: "all", label: "All", Component: AllBondsTab },
	{ id: "open", label: "Open", Component: OpenBondsTab, isDefault: true },
	{ id: "closed", label: "Closed", Component: ClosedBondsTab },
];

type AdminAccountBondsTabProps = AccountTabProps;

export const AdminAccountBondsTab: FC<AdminAccountBondsTabProps> = ({ accountId }) => {
	const [activeBondSectionTab, setActiveBondSectionTab] = useState(
		getDefaultTab(BOND_SECTION_TABS),
	);

	const Component = activeBondSectionTab.Component;

	return (
		<div className="flex flex-col space-y-[45px] pb-[125px]">
			<Card elevation="raised" className="rounded-xl" data-testid="admin-account-bonds-card">
				<Card.Body className="p-6">
					<div className="flex flex-col w-full space-y-2">
						<div className="flex items-center justify-between">
							<TabBar
								options={BOND_SECTION_TABS}
								activeTabId={activeBondSectionTab.id}
								onTabChange={(id) => {
									const tab = BOND_SECTION_TABS.find((t) => t.id === id);
									if (tab) setActiveBondSectionTab(tab);
								}}
							/>
						</div>
						<Component accountId={accountId} />
					</div>
				</Card.Body>
			</Card>
		</div>
	);
};
